<div class="perfil-wrapper">

    <div class="perfil-header">
        <div class="perfil-picture">
            <img src="assets/logo-black-orange.svg" alt="seller-profile-picture">
        </div>

        <div class="perfil-title">
            <h1>Shop Name</h1>
            <h3>Shop Description</h3>
            <h4>Horario de funcionamento</h4>
            <h5>Endereço</h5>
        </div>
    </div>

    <div class="perfil-body-part">
        <div class="seller-options">
            <div class="buttons">
                <a class="button" href="/">
                    <h3>Painel de Estoque</h3>
                </a>

                <a class="button" href="/">
                    <h3>Fechar caixa</h3>
                </a>

                <a class="button" href="/">
                    <h3>Alterar foto de perfil</h3>
                </a>

                <a class="button" href="/1">
                    <h3>Definir horários de funcionamento</h3>
                </a>

                <a class="button" href="/2">
                    <h3>Adicionar/Remover itens do cardápio</h3>
                </a>
            </div>
        </div>

        <div class="perfil-seller-data">
            <h3>Informações da Loja</h3>
            <div class="shop-data">

                <div class="personalBalance">
                    <h3>Campeão em vendas: </h3>
                    <p>a</p>
                    <p>b</p>
                    <p>c</p>
                    <p>c</p>
                </div>

                <div class="personalBalance">
                    <h3>Lucro até o momento: </h3>
                    <p>a</p>
                    <p>b</p>
                    <p>c</p>
                    <p>c</p>
                </div>

                <div class="personalBalance">
                    <h3>Horário de atendimento: </h3>
                    <p>a</p>
                    <p>b</p>
                    <p>c</p>
                    <p>c</p>
                </div>

                <div class="personalBalance">
                    <h3>Total de pedidos: </h3>
                    <p>a</p>
                    <p>b</p>
                    <p>c</p>
                    <p>c</p>
                </div>
            </div>
        </div>
    </div>

</div>
